import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from 'store'
import './i18n'

// Initialize Socket Io
import 'socket'

// Components
import App from 'modules/App'
import { Suspense } from 'react'
import SuspenseLoader from 'modules/App/SuspenseLoader'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found')
}

createRoot(rootEl).render(
  <Suspense fallback={<SuspenseLoader />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </Suspense>,
)
